<template>
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
  >
    <path
      fill="#85c441"
      d="M67.3,60.69c-1.09-.4-1.44,.17-2.41,.25-2.28,.17-4.26,.53-6.18-.47-.67-.35-1.2-1.32-1.96-1.55-.86-.26-1.64,0-2.46,.2-1.21,.29-.74,.38-1.55,.68-.98,.18-2.05,.39-3.12,.53-1.8-.03-3.4-.66-5.41-1.22-2.05-.58-2.9-.31-4.13,.18-.04,.01-.07,.02-.1,.03-.07,.03-.12,.05-.18,.08-.43,.17-.91,.36-1.51,.55-3.01,.95-5.8-2.12-8.71-.12-1.74,1.2-1.46,1-.71,3.19,.47,1.38,1.68,6.44,3.38,7.02,.11,.04,.22,0,.3-.08l.26-.24c.07-.05,.12-.12,.11-.22,0-.02,0-.04,0-.05,0-.01,0-.03,0-.04v-.03h-.01c-.88-2.26-2.41-4.65-2.91-7.01-.25-1.16-.74-.83-.02-1.69,.8-.96,4.52,1.2,5.27,1.23,1.83,.07,1.66-.21,3.4-.91,4.61-1.86,6.54,1.1,10.42,.93,3.07-.13,5.23-1.95,8.61-.72,1.2,.44,1.88,1.4,3.33,1.6,1.64,.22,5.93-1.73,6.69,.39,.4,1.12-1.8,4.67-2.06,5.91-.04,.17,.05,.32,.22,.38l.3,.1c.1,.03,.22,0,.3-.08,1.09-1.03,2.44-4.92,2.43-6.26,0-1.12-.21-2.04-1.56-2.53Zm-33.55-.28s.05,.01,.08,.02c.21,.06,.39,.13,.56,.2-.05-.01-.1-.02-.16-.04-.2-.05-.35-.12-.48-.19Zm34.11,4.09c.14-.42,.29-.74,.4-1.03-.08,.48-.35,1.11-.63,1.7,.1-.27,.18-.5,.23-.68Z"
    />
    <g>
      <path
        fill="#85c441"
        d="M69.27,61.42c-.67,.02-.67,.11-.74,.31-.09,.07-.15,.18-.17,.31h0c-.1,.14-.25,.3-.52,.48-.27,1.23-1.12,1.92-2.54,2.06-.05,.05-.1,.09-.15,.14-.18-.02-.36-.05-.56-.09-.71,.54-1.36,.83-1.96,.88-.47-.15-.94-.47-1.41-.96-.69-.42-1.18-1.03-1.97-1.31-1.68-.6-2.79,.05-4.38,.41-2.98,.67-5.77,2.3-8.89,1.05-1.31-.52-2.36-1.51-3.64-2.03-1.33-.55-2.35-.79-3.78-.36-.69,.2-1.29,.86-1.92,1.18-.04,.02-.06,.03-.09,.05-.09,.04-.17,.07-.26,.1-2.39,.47-4.14-.02-5.25-1.47-.22-.29-.45-.58-.69-.86-1.49-.66-2.75-1.43-3.1,.91,0,.06,.01,.11,.02,.16-.42,1.49,1.15,4.18,1.53,5.33,1.11,3.41,2.3,6.74,4.23,9.79,3.55,5.61,7.83,8.37,14.51,8.38,6.49,.02,10.91-1.32,14.93-6.65,3.07-4.06,7.42-12.22,7.21-17.41,0-.2-.17-.39-.39-.39Z"
      />
      <g>
        <ellipse
          fill="#fff"
          cx="48.46"
          cy="74.19"
          rx="7.03"
          ry="5.83"
        />
        <g>
          <polygon
            fill="#582816"
            points="46 71.39 45.13 70.84 45.34 71.76 46 71.39"
          />
          <path
            fill="#582816"
            d="M48.6,76.39c.03,1.04,.07,1.82,.57,2.74,.11,.2-.12,.29-.21,.13-.55-.97-.69-2.03-.72-3.13,0-.2,.36,.12,.37,.26h0Z"
          />
          <path
            fill="#582816"
            d="M48.03,76c-.26,.99-.38,1.93-.17,2.93,.06,.29-.19,.35-.25,.06-.24-1.12-.08-2.2,.21-3.31,.07-.26,.25,.19,.21,.32h0Z"
          />
          <polygon
            fill="#582816"
            points="45.66 71.22 44.78 71.71 45.69 71.99 45.66 71.22"
          />
          <path
            fill="#582816"
            d="M51.03,74.24c-.09,.24-.25,.49-.48,.74-.47,.49-1.28,.73-2.12,.44,.96,.19,1.74-.33,2.18-.92,.07-.09,.13-.19,.18-.29h0c.46-.86,.37-1.94,.15-2.34-.59,.88-1.37,1.08-2.01,1.1-.02-.08-.02-.15-.02-.23,.06-1.69-.18-3.44-1.96-3.1-2.07,.4-1.92,4.81-.51,6.52,.7,.86,2.27,1.85,4.43,1.13,2.17-.72,2.51-3.68,2.51-3.68-.76,.5-1.6,.67-2.35,.62Z"
          />
          <path
            fill="#fff"
            d="M47.64,71.61c-.03,.28-.29,.48-.58,.44-.29-.04-.5-.3-.47-.58,.03-.28,.29-.48,.58-.44,.29,.04,.5,.3,.47,.58Z"
          />
          <path
            fill="#582816"
            d="M47.35,71.57c-.01,.12-.13,.21-.25,.19-.13-.02-.22-.13-.2-.25,.01-.12,.13-.21,.25-.19,.13,.02,.22,.13,.2,.25Z"
          />
        </g>
      </g>
    </g>
    <path
      fill="#4f2b1b"
      d="M79.65,42.17c4.33,12.07,1.68,25.73-7.22,35.04-8.09,8.46-20.27,12.24-31.72,9.69-11.15-2.49-20.63-10.69-24.48-21.49s-1.91-23.73,5.58-32.8,20.27-14.17,32.34-11.87c1.88,.36,3.72,.88,5.53,1.52,2.73,.97,3.91-3.37,1.2-4.34-13.54-4.83-28.97-1.53-39.35,8.4-9.6,9.18-13.71,22.98-10.88,35.93s12.28,23.31,24.51,27.73,26.78,1.88,37.08-6.47c10.76-8.73,15.78-22.96,13.36-36.52-.36-2.04-.92-4.04-1.62-6-.41-1.14-1.53-1.91-2.77-1.57-1.11,.3-1.98,1.62-1.57,2.77h0Z"
    />
    <path
      fill="#4f2b1b"
      d="M33.3,56.76c1.4-2.81,2.37-6.17,.58-9.06-.75-1.2-1.73-2.06-2.07-3.5-.36-1.51,.24-2.91,1.26-4.01,1.31-1.42-.81-3.54-2.12-2.12-2.49,2.7-2.95,6.4-.9,9.51,.86,1.31,1.87,2.2,1.82,3.89-.03,1.33-.58,2.61-1.16,3.78-.86,1.72,1.73,3.25,2.59,1.51h0Z"
    />
    <path
      fill="#4f2b1b"
      d="M45.3,56.76c1.4-2.81,2.37-6.17,.58-9.06-.75-1.2-1.73-2.06-2.07-3.5-.36-1.51,.24-2.91,1.26-4.01,1.31-1.42-.81-3.54-2.12-2.12-2.49,2.7-2.95,6.4-.9,9.51,.86,1.31,1.87,2.2,1.82,3.89-.03,1.33-.58,2.61-1.16,3.78-.86,1.72,1.73,3.25,2.59,1.51h0Z"
    />
    <path
      fill="#4f2b1b"
      d="M38.3,41.76c1.4-2.81,2.37-6.17,.58-9.06-.75-1.2-1.73-2.06-2.07-3.5-.36-1.51,.24-2.91,1.26-4.01,1.31-1.42-.81-3.54-2.12-2.12-2.49,2.7-2.95,6.4-.9,9.51,.86,1.31,1.87,2.2,1.82,3.89-.03,1.33-.58,2.61-1.16,3.78-.86,1.72,1.73,3.25,2.59,1.51h0Z"
    />
    <g>
      <path
        fill="#fff"
        d="M49.47,40.87l8.6,7.13h9.23l14.24-15.11c.63-.67,.62-1.72-.04-2.37l-10.62-10.56c-.74-.73-1.93-.73-2.67,0l-18.84,18.74c-.62,.61-.57,1.62,.1,2.17Z"
      />
      <path
        fill="#85c441"
        d="M67.94,49.5h-10.42l-9.01-7.47c-.64-.53-1.03-1.32-1.07-2.15-.04-.83,.28-1.65,.87-2.24l18.85-18.75c1.32-1.31,3.47-1.31,4.79,0l10.62,10.56c1.24,1.23,1.27,3.19,.07,4.46l-14.69,15.59Zm-9.34-3h8.04l13.8-14.64c.07-.08,.07-.2,0-.28l-10.62-10.56c-.15-.15-.4-.15-.55,0l-18.82,18.72,8.16,6.76Z"
      />
    </g>
    <path
      fill="#4f2b1b"
      d="M61.5,60.5c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
    />
    <path
      fill="#4f2b1b"
      d="M57.5,55.5c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
    />
    <path
      fill="#4f2b1b"
      d="M65,55.5c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5Z"
    />
  </svg>
</template>
